import React, { Component } from 'react';
import moment from "moment";
import {isInt, isFloat} from 'validator';

// Components
import DateInput from "../../components/common/date-input";
import StatusSelector from "../../components/common/StatusSelector";

class EmployeeDetail extends Component {

    constructor(props) {
        super(props);

        this.state = {
            employee_code: this.props.employee.get('employee_code') || '',
            fiscal_id: this.props.employee.get('fiscal_id') || '',
            laboral_id: this.props.employee.get('laboral_id') || '',
            name: this.props.employee.get('name') || '',
            last_name: this.props.employee.get('last_name') || '',
            date_of_birth: moment(this.props.employee.get('date_of_birth')),
            contract_type: this.props.employee.get('contract_type') || '',
            category: this.props.employee.get('category') || '',
            cost_per_hour: this.props.employee.get('cost_per_hour') || '',
            address: this.props.employee.get('address') || '',
            country: this.props.employee.get('country') || '',
            province: this.props.employee.get('province') || '',
            city: this.props.employee.get('city') || '',
            postal_code: this.props.employee.get('postal_code') || '',
            email: this.props.employee.get('email') || '',
            phone: this.props.employee.get('phone') || '',
            mobile_phone: this.props.employee.get('mobile_phone') || '',
            bank_info_name: this.props.employee.getIn(['bank_info', 'name']) || '',
            bank_info_iban: this.props.employee.getIn(['bank_info', 'iban']) || '',
            bank_info_swift: this.props.employee.getIn(['bank_info', 'swift']) || ''
        }
    }

    componentDidMount() {
        this.props.onRef(this);
    }
    componentDidUpdate(prevProps) {
        if (this.props.employee !== prevProps.employee) {
            this.updateEmployeesState();
        }
    }
    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    updateEmployee = () => {
        this.props.updateEmployee(this.props.employee.get('_id'), {
            employee_code: this.state.employee_code,
            fiscal_id: this.state.fiscal_id,
            laboral_id: this.state.laboral_id,
            name: this.state.name,
            last_name: this.state.last_name,
            date_of_birth: this.state.date_of_birth,
            contract_type: this.state.contract_type,
            category: this.state.category,
            cost_per_hour: this.state.cost_per_hour,
            address: this.state.address,
            ...(this.state.country !== '') ? { country: this.state.country } : this.props.employee.get('country'),
            ...(this.state.province !== '') ? { province: this.state.province } : this.props.employee.get('province'),
            ...(this.state.city !== '') ? { city: this.state.city } : this.props.employee.get('city'),
            postal_code: this.state.postal_code,
            email: this.state.email,
            phone: this.state.phone,
            mobile_phone: this.state.mobile_phone,
            bank_info: {
                name: this.state.bank_info_name,
                iban: this.state.bank_info_iban,
                swift: this.state.bank_info_swift
            }
        });
        this.updateEmployeesState();
    };
    updateEmployeesState = () => {
        this.setState({
            employee_code: this.props.employee.get('employee_code') || '',
            fiscal_id: this.props.employee.get('fiscal_id') || '',
            laboral_id: this.props.employee.get('laboral_id') || '',
            name: this.props.employee.get('name') || '',
            last_name: this.props.employee.get('last_name') || '',
            date_of_birth: moment(this.props.employee.get('date_of_birth')),
            contract_type: this.props.employee.get('contract_type') || '',
            category: this.props.employee.get('category') || '',
            cost_per_hour: this.props.employee.get('cost_per_hour') || '',
            address: this.props.employee.get('address') || '',
            country: this.props.employee.get('country') || '',
            province: this.props.employee.get('province') || '',
            city: this.props.employee.get('city') || '',
            postal_code: this.props.employee.get('postal_code') || '',
            email: this.props.employee.get('email') || '',
            phone: this.props.employee.get('phone') || '',
            mobile_phone: this.props.employee.get('mobile_phone') || '',
            bank_info_name: this.props.employee.getIn(['bank_info', 'name']) || '',
            bank_info_iban: this.props.employee.getIn(['bank_info', 'iban']) || '',
            bank_info_swift: this.props.employee.getIn(['bank_info', 'swift']) || ''
        })
    };

    onChangeInput = (inputName, inputValue) => {
        this.setState({
            [inputName]: inputValue
        }, this.validateEmployee);
    };
    validateEmployee = () => {
        if (
            this.state.name !== '' &&
            this.state.cost_per_hour !== ''
        ) {
            this.props.canSubmit(true);
        }
        else {
            this.props.canSubmit(false);
        }
    };

    render() {
        const modeView = this.props.mode === 'view';
        let statusColor = '', statusText = '';

        switch (this.props.employee.get('status')) {
            case 'active':
                statusColor = 'primary';
                statusText = 'Activo';
                break;
            case 'inactive':
                statusColor = 'danger';
                statusText = 'Inactivo';
                break;
            default:
                break;
        }

        return (
            <div className="panel-body" >
                <div className="row">
                    <div className="col-3">
                        <div className="form-group">
                            <label>Código de empleado *</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.employee_code}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>NIF / NIE</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.fiscal_id}
                                disabled={modeView}
                                onChange={ (event) => this.onChangeInput('fiscal_id', event.target.value) }
                            />
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>Nº Seguridad Social</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.laboral_id}
                                disabled={modeView}
                                onChange={ (event) => this.onChangeInput('laboral_id', event.target.value) }
                            />
                        </div>
                    </div>
                    <div className="col-3 ml-auto">
                        <label>Estado</label>
                        { modeView
                            ? <div className="row">
                                <div className="col-6">
                                    <span className={ 'status-label label-' + statusColor } >{ statusText }</span>
                                </div>
                                <div className="col-auto d-flex align-items-center" style={{ paddingLeft: 0 }} >
                                    <StatusSelector
                                        statusObject={this.props.employee}
                                        statusOptions={['active', 'inactive']}
                                        changeStatus={this.props.changeEmployeeStatus}
                                    />
                                </div>
                            </div>
                            : <div className="row">
                                <div className="col-6">
                                    <span className={ 'status-label label-' + statusColor } >{ statusText }</span>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="form-group">
                            <label>Nombre *</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.name}
                                disabled={modeView}
                                onChange={ (event) => this.onChangeInput('name', event.target.value) }
                            />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="form-group">
                            <label>Apellidos</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.last_name}
                                disabled={modeView}
                                onChange={ (event) => this.onChangeInput('last_name', event.target.value) }
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-3">
                        <div className="form-group">
                            <label>Fecha de nacimiento</label>
                            <DateInput
                                onChange={(selectedValue) => this.setState({
                                    date_of_birth: selectedValue
                                })}
                                value={this.state.date_of_birth}
                                inputWrapperStyle={{height: 40}}
                                inputStyle={{height: 37, borderRadius: 0, border: '1px solid #ccc'}}
                                iconStyle={{top: 9, right: 12}}
                                disabled={modeView}
                            />
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>Tipo de contrato</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.contract_type}
                                disabled={modeView}
                                onChange={ (event) => this.onChangeInput('contract_type', event.target.value) }
                            />
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>Categoría</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.category}
                                disabled={modeView}
                                onChange={ (event) => this.onChangeInput('category', event.target.value) }
                            />
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>Coste por hora(€) *</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.cost_per_hour}
                                disabled={modeView}
                                onChange={ (event) => {
                                    let cost_per_hour = event.target.value;
                                    if (cost_per_hour === '') cost_per_hour = '0';
                                    if (isFloat(cost_per_hour)) {
                                        this.onChangeInput('cost_per_hour', cost_per_hour);
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                <h4>Domicilio</h4>
                <div className="row">
                    <div className="col-12">
                        <div className="form-group">
                            <label>Dirección</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.address}
                                disabled={modeView}
                                onChange={ (event) => this.onChangeInput('address', event.target.value) }
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-3">
                        <div className="form-group">
                            <label>País</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.country}
                                disabled={modeView}
                                onChange={ (event) => this.onChangeInput('country', event.target.value) }
                            />
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>Provincia</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.province}
                                disabled={modeView}
                                onChange={ (event) => this.onChangeInput('province', event.target.value) }
                            />
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>Población</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.city}
                                disabled={modeView}
                                onChange={ (event) => this.onChangeInput('city', event.target.value) }
                            />
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>Código Postal</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.postal_code}
                                disabled={modeView}
                                onChange={ (event) => {
                                    const postal_code = event.target.value;
                                    if (isInt(postal_code) || postal_code === '') {
                                        this.onChangeInput('postal_code', postal_code);
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                <h4>Contacto</h4>
                <div className="row">
                    <div className="col-3">
                        <div className="form-group">
                            <label>Email</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.email}
                                disabled={modeView}
                                onChange={ (event) => this.onChangeInput('email', event.target.value) }
                            />
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>Teléfono</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.phone}
                                disabled={modeView}
                                onChange={ (event) => this.onChangeInput('phone', event.target.value) }
                            />
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>Móvil</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.mobile_phone}
                                disabled={modeView}
                                onChange={ (event) => this.onChangeInput('mobile_phone', event.target.value) }
                            />
                        </div>
                    </div>
                </div>
                <h4>Datos Bancarios</h4>
                <div className="row">
                    <div className="col-6">
                        <div className="form-group">
                            <label>Banco</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.bank_info_name}
                                disabled={modeView}
                                onChange={ (event) => this.onChangeInput('bank_info_name', event.target.value) }
                            />
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>IBAN</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.bank_info_iban}
                                disabled={modeView}
                                onChange={ (event) => this.onChangeInput('bank_info_iban', event.target.value) }
                            />
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>Swift</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.bank_info_swift}
                                disabled={modeView}
                                onChange={ (event) => this.onChangeInput('bank_info_swift', event.target.value) }
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default EmployeeDetail;



// WEBPACK FOOTER //
// ./src/containers/employees/EmployeeDetail.js